/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function WebhookIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="webhook"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M6.263 15.717L10.34 8.483" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M11.649 5.173L15.876 12.321" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M18.088 15.11L9.784 15.196" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M10.34 8.483A3.559 3.559 0 1 1 14 2.5" data-tinysvg-shape="arc" data-tinysvg-arc="11.649 5.173 3.559 3.559 111.58 311.332 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M15.876 12.321A3.559 3.559 120 1 1 19.227 18.482" data-tinysvg-shape="arc" data-tinysvg-arc="18.088 15.11 3.559 3.559 111.58 311.332 120 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M9.784 15.196A3.559 3.559 240 1 1 2.773 15.018" data-tinysvg-shape="arc" data-tinysvg-arc="6.263 15.717 3.559 3.559 111.58 311.332 240 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
